import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="hero" id="home">
      <div className="hero-overlay"></div>
      <div className="container hero-content">
        <img src="/logo.png" alt="CAEI Logo" className="hero-logo" />
        <h1 className="hero-title">Supporting Survivors. Restoring Hope. Building Stronger Communities.</h1>
        <p className="hero-subtitle">
          At Community Awareness and Empowerment Initiative, we provide free and confidential counseling and psychosocial support to survivors of violence.
        </p>
        <p className="hero-description">
          We work with communities to promote healing, reduce stigma around mental health, and empower individuals to rebuild their lives with dignity.
        </p>
        <div className="hero-buttons">
          <Link to="/about" className="btn btn-primary">Learn More</Link>
          <Link to="/services" className="btn btn-secondary">Our Programs</Link>
          <Link to="/contact" className="btn btn-outline">Get Involved</Link>
        </div>
      </div>
    </header>
  );
};

export default Hero;
